<template>
    <div :id="id">
        <table :id="id+'_table'" class="ui selectable celled unstackable table" style="width: 100%">
        </table>
    </div>
</template>
<script>
  import EventBus from '@/util/EventBus'
  import HttpUtil from '@/util/HttpUtil'

  const actionTemplate = '<a href="#" data-action="{action}" data-tooltip="{tooltip}"  data-inverted=""> <i class="icon {icon}"></i>{name}</a>'
  export default {
    data () {
      return {
        tabla: null,
        onAdd: (action) => {
          this.tabla.row.add(action.data).draw(false)
        },
        onAddAll: (action) => {
          this.tabla.rows.add(action.data).draw(false)
        },
        onEdit: (action) => {
          action.row.data(action.data)
        },
        onDelete: (action) => {
          action.row.remove().draw(false)
        },
        onRefresh: (action) => {
          this.tabla.clear()
          this.tabla.rows.add(this.dtOptions.data).draw()
          this.$emit('action', {
            action: 'initComplete',
            row: null
          })
        }
      }
    },
    /* El atributo dtOptions es utilizado para inicializar las datatables por lo que se puede utilizar el api como se desee
     * sobre escribe todas las configuraciones del componente.
     *
     * Si se envia el atributo dtOptions.serverSide en true se activa la configuración ajax de este componente
     * Para utilizar recursos ajax en esta implementación, se recomienda enviar el atributo endpoint en el objeto dtOptions
     * aunque no es parte de la implementación de datatables será utilizado para generar la configuración ajax y la paginacióm.
     * Si en el objeto dtOptions se envía el atributo ajax, este sobre escribe la configuracion realizada por esta implementación.
     *
     * Nota: siempre se utiliza columnDefs para definir las columnas de la tabla.
     * Se puede definir los datos quemados de la tabla con el atributo data.
     */
    props: ['id', 'actions', 'dtOptions', 'data', 'allowSelection'],
    created: function () {
      /**
       * Este componente escucha los eventos del crud sobre la tabla, los componentes que lo utilicen
       * deben ejecutar estos eventos para notificar al componente que debe actualiar la GUI
       */
      EventBus.$on(this.id + '_add', this.onAdd)
      EventBus.$on(this.id + '_addAll', this.onAddAll)
      EventBus.$on(this.id + '_edit', this.onEdit)
      EventBus.$on(this.id + '_delete', this.onDelete)
      EventBus.$on(this.id + '_refresh', this.onRefresh)
    },
    destroyed: function () {
      EventBus.$off(this.id + '_add', this.onAdd)
      EventBus.$off(this.id + '_addAll', this.onAddAll)
      EventBus.$off(this.id + '_edit', this.onEdit)
      EventBus.$off(this.id + '_delete', this.onDelete)
      EventBus.$off(this.id + '_refresh', this.onRefresh)
    },
    mounted: function () {
      this.dtOptionsFinal = jQuery.extend(true, {}, this.dtOptions)
      if (this.actions instanceof Array) {
        let renderer = (data, type, row, meta) => {
          if (type === 'filter') {
            let dom = ''
            for (let i = 0; i < this.actions.length; i++) {
              let action = this.actions[i]
              if (typeof action.render === 'function') {
                dom += action.render(data, type, row, meta)
              } else {
                dom += action.name + '|'
              }
            }
            return dom
          }

          if (type === 'display') {
            let dom = ''
            for (let i = 0; i < this.actions.length; i++) {
              let action = this.actions[i]
              if (typeof action.render === 'function') {
                dom += action.render(data, type, row, meta)
              } else {
                dom += actionTemplate.replace('{action}', action.action).replace('{name}', action.name).replace('{icon}', action.icon).replace('{tooltip}', action.tooltip)
              }
            }
            return dom
          }

          return data
        }

        let actionsCol = {
          title: 'Acciones',
          targets: this.dtOptionsFinal.columnDefs.length,
          sorting: false,
          orderable: false,
          searchable: false,
          type: 'html',
          render: renderer,
          data: null
        }
        this.dtOptionsFinal.columnDefs.push(actionsCol)
      }

      this.tablaId = '#' + this.id + '_table'
      this.filterId = '#' + this.id + '_table_filter'

      let componentOptions = {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
        },
        scrollX: true,
        initComplete: () => {
          /* fix de la paginación */
          jQuery('#' + this.id).find('.ui.stackable.pagination.menu').removeClass('stackable')

          this.$emit('action', {
            action: 'initComplete',
            row: null,
            table: this.tabla
          })
        }
      }

      if (typeof this.data !== 'undefined' && this.data !== null && this.data !== '') {
        componentOptions.data = this.data
      }

      if (typeof this.dtOptionsFinal.endpoint !== 'undefined' && this.dtOptionsFinal.endpoint !== null && this.dtOptionsFinal.endpoint !== '') {
        /* se realiza la configuración ajax */
        componentOptions.ajax = {
          type: 'POST',
          url: this.$store.state.appSettings.apiurl + '/' + this.dtOptionsFinal.endpoint + '/dt',
          headers: HttpUtil.getHeaders()
        }
        componentOptions.processing = true
        componentOptions.serverSide = true
      }

      let dtConfig = jQuery.extend(true, componentOptions, this.dtOptionsFinal)

      /* Evento xhr */
      jQuery(this.tablaId).on('xhr.dt', (e, settings, json, xhr) => {
        this.$emit('action', {
          action: 'xhr.dt',
          e: e,
          settings: settings,
          json: json,
          xhr: xhr
        })
      })

      this.tabla = jQuery(this.tablaId).DataTable(dtConfig)

      jQuery(this.tablaId + ' tbody').on('click', 'a', (e) => {
        let actionElement = e.target.tagName !== 'A' ? jQuery(e.target).closest('A') : jQuery(e.target)
        if (!actionElement.hasClass('noDtPrevent')) {
          e.preventDefault()
        }
        let row = this.tabla.row(actionElement.parents('tr'))
        this.$emit('action', {
          action: actionElement.data('action'),
          row: row
        })
      })

      if (typeof this.allowSelection !== 'undefined' && (this.allowSelection === 'true' || this.allowSelection === true)) {
        jQuery(this.tablaId + ' tbody').on('click', 'tr', (e) => {
          e.preventDefault()
          if (e.target.tagName === 'I') {
            return
          }

          let actionElement = e.target.tagName !== 'TR' ? jQuery(e.target).closest('tr') : jQuery(e.target)
          if (actionElement.hasClass('selected')) {
            actionElement.removeClass('selected')
            this.$emit('action', {
              action: 'rowSelected',
              row: null
            })
          } else {
            let row = this.tabla.row(actionElement)
            if (row.data && typeof row.data() !== 'undefined') {
              this.tabla.$('tr.selected').removeClass('selected')
              actionElement.addClass('selected')
              this.$emit('action', {
                action: 'rowSelected',
                row: row
              })
            }
          }
        })
      }

      let searchDelay = null

      /* Configuración del retraso al buscar */
      jQuery(this.tablaId).on('init.dt', () => {
        /* Retiro el evento de busqueda */
        jQuery(this.filterId + ' input').off('keyup.DT input.DT').wrap('<span class="ui input"></span>')

        jQuery(this.filterId + ' input').on('keyup', () => {
          let search = jQuery(this.filterId + ' input').val()
          clearTimeout(searchDelay)

          searchDelay = setTimeout(() => {
            if (search != null) {
              this.tabla.search(search).draw()
            }
          }, 500)
        })
      })
    },
    watch: {
      data: function (newValue) {
        this.tabla.clear()
        this.tabla.rows.add(newValue).draw()
      }
    }
  }
</script>
<style>
    .dataTables_scrollBody thead tr[role="row"] {
        visibility: collapse !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ui/datatables/DataTables.vue